import React from 'react';
import { useNavigate, ScrollRestoration } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import AnimateOnScroll from './AnimateOnScroll';
import dekorativne from '../resources/dekorativne.jpg';
import kamen from '../resources/Kamenivo 8-16.jpeg';
import piesok from '../resources/piesok.jpg';
import strkopiesky from '../resources/strkopiesky.jpg';
import 'animate.css';

const categories = [
  { img: strkopiesky, label: 'Štrkopiesky',   desc: 'Ťažené riečne kamenivo pre stavby, základy a záhrady.',         route: '/ponuka/strkopiesky' },
  { img: kamen,       label: 'Kamenivo',       desc: 'Drvené kamenivo rôznych frakcií pre spevnené plochy a betóny.', route: '/ponuka/kamenivo'    },
  { img: piesok,      label: 'Piesok',         desc: 'Jemné piesky vhodné pre malty, omietky a betónové zmesi.',      route: '/ponuka/piesok'      },
  { img: dekorativne, label: 'Okrasný kameň',  desc: 'Dekoratívne kamenivo pre záhrady, skalky a gabióny.',           route: '/ponuka/okrasny'     },
];

function Ponuka() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <PageHero title="Naša" highlight="ponuka" subtitle="Vyberte si kategóriu stavebného materiálu." />

      <div className="max-w-screen-xl mx-auto w-full px-6 py-14 flex-1">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
          {categories.map((cat, i) => (
            <AnimateOnScroll key={i} delay={i * 80}>
              <div
                className="group cursor-pointer rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 bg-white"
                onClick={() => navigate(cat.route)}
              >
                <div className="relative overflow-hidden h-52">
                  <img
                    src={cat.img}
                    alt={cat.label}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-all duration-300" />
                </div>
                <div className="p-5 border-t-4 border-red-600">
                  <h2 className="text-xl font-bold text-gray-800 mb-1">{cat.label}</h2>
                  <p className="text-gray-500 text-sm leading-relaxed">{cat.desc}</p>
                  <span className="inline-block mt-4 text-red-600 font-semibold text-sm group-hover:underline">
                    Zobraziť produkty →
                  </span>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>

      <Footer />
      <ScrollRestoration />
    </div>
  );
}

export default Ponuka;
